// Theme: light-protocol
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'light-protocol',
  name: 'Light Protocol',
  tagline: 'PROTOCOL',
  description: 'Painel de progressao funcional em modo claro. Limpo, acessivel e de alta legibilidade.',
  category: 'system-core',
  tier: 'common',
  basePrice: 0,
  swatches: ['#FAFCFD', '#0092BD', '#F5F9FB', '#0F1A2C'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '8px',
      '--shadow-card': '0 8px 20px rgba(15, 26, 44, 0.08)',
      '--shadow-card-active': '0 10px 24px rgba(15, 26, 44, 0.12)'
    },
    shellClasses: 'font-sans theme-light-protocol'
  },
  colorVars: {
    '--accent': '#0092BD',
    '--accent-foreground': 'oklch(0.99 0.005 194)',
    '--background': '#FAFCFD',
    '--border': '#DFE6E8',
    '--card': '#F5F9FB',
    '--card-border-active': 'rgba(0, 146, 189, 0.18)',
    '--card-completed': '#EDF9ED',
    '--card-foreground': '#0F1A2C',
    '--card-glow': 'rgba(0, 146, 189, 0.05)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#C53637',
    '--destructive-foreground': 'oklch(0.99 0.005 194)',
    '--foreground': '#0F1A2C',
    '--hold-fill': '#0092BD',
    '--input': '#DFE6E8',
    '--modal-bg': '#FAFCFD',
    '--modal-border': '#DFE6E8',
    '--modal-overlay-bg': 'rgba(15, 26, 44, 0.45)',
    '--modal-shadow': '0 8px 30px rgba(15, 26, 44, 0.12)',
    '--muted': '#EEF3F5',
    '--muted-foreground': '#6A737A',
    '--nav-active': '#0092BD',
    '--nav-bg': '#FAFCFD',
    '--popover': '#FAFCFD',
    '--popover-foreground': '#0F1A2C',
    '--premium': '#6F3BB2',
    '--primary': '#0092BD',
    '--primary-foreground': 'oklch(0.99 0.005 194)',
    '--rarity-epic': '#6F3BB2',
    '--rarity-legendary': '#AD721C',
    '--rarity-rare': '#1C50A7',
    '--rarity-secret': '#A20519',
    '--ring': '#0092BD',
    '--secondary': '#EEF3F5',
    '--secondary-foreground': '#343C42',
    '--streak': '#2F9F3D',
    '--success': '#2F9F3D',
    '--success-foreground': 'oklch(0.99 0.005 194)',
    '--xp': '#0092BD',
    '--xp-bg': '#EEF7FA'
  },
  resolvedVars: {
    '--accent': '#0092BD',
    '--accent-foreground': 'oklch(0.99 0.005 194)',
    '--accent-foreground-hsl': '200 43% 99%',
    '--accent-foreground-oklch': '0.99 0.005 194',
    '--accent-hsl': '194 100% 37%',
    '--accent-oklch': 'from #0092BD l c h',
    '--background': '#FAFCFD',
    '--background-hsl': '200 43% 99%',
    '--background-oklch': 'from #FAFCFD l c h',
    '--border': '#DFE6E8',
    '--border-hsl': '193 16% 89%',
    '--border-oklch': 'from #DFE6E8 l c h',
    '--border-w': '1px',
    '--card': '#F5F9FB',
    '--card-border-active': 'rgba(0, 146, 189, 0.18)',
    '--card-completed': '#EDF9ED',
    '--card-completed-hsl': '120 50% 95%',
    '--card-completed-oklch': 'from #EDF9ED l c h',
    '--card-foreground': '#0F1A2C',
    '--card-foreground-hsl': '217 49% 12%',
    '--card-foreground-oklch': 'from #0F1A2C l c h',
    '--card-glow': 'rgba(0, 146, 189, 0.05)',
    '--card-hsl': '200 43% 97%',
    '--card-oklch': 'from #F5F9FB l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#C53637',
    '--destructive-foreground': 'oklch(0.99 0.005 194)',
    '--destructive-foreground-hsl': '200 43% 99%',
    '--destructive-foreground-oklch': '0.99 0.005 194',
    '--destructive-hsl': '360 57% 49%',
    '--destructive-oklch': 'from #C53637 l c h',
    '--foreground': '#0F1A2C',
    '--foreground-hsl': '217 49% 12%',
    '--foreground-oklch': 'from #0F1A2C l c h',
    '--hold-fill': '#0092BD',
    '--hold-fill-hsl': '194 100% 37%',
    '--hold-fill-oklch': 'from #0092BD l c h',
    '--input': '#DFE6E8',
    '--input-hsl': '193 16% 89%',
    '--input-oklch': 'from #DFE6E8 l c h',
    '--modal-bg': '#FAFCFD',
    '--modal-bg-hsl': '200 43% 99%',
    '--modal-bg-oklch': 'from #FAFCFD l c h',
    '--modal-border': '#DFE6E8',
    '--modal-border-hsl': '193 16% 89%',
    '--modal-border-oklch': 'from #DFE6E8 l c h',
    '--modal-overlay-bg': 'rgba(15, 26, 44, 0.45)',
    '--modal-shadow': '0 8px 30px rgba(15, 26, 44, 0.12)',
    '--muted': '#EEF3F5',
    '--muted-foreground': '#6A737A',
    '--muted-foreground-hsl': '206 7% 45%',
    '--muted-foreground-oklch': 'from #6A737A l c h',
    '--muted-hsl': '197 26% 95%',
    '--muted-oklch': 'from #EEF3F5 l c h',
    '--nav-active': '#0092BD',
    '--nav-active-hsl': '194 100% 37%',
    '--nav-active-oklch': 'from #0092BD l c h',
    '--nav-bg': '#FAFCFD',
    '--nav-bg-hsl': '200 43% 99%',
    '--nav-bg-oklch': 'from #FAFCFD l c h',
    '--popover': '#FAFCFD',
    '--popover-foreground': '#0F1A2C',
    '--popover-foreground-hsl': '217 49% 12%',
    '--popover-foreground-oklch': 'from #0F1A2C l c h',
    '--popover-hsl': '200 43% 99%',
    '--popover-oklch': 'from #FAFCFD l c h',
    '--premium': '#6F3BB2',
    '--premium-foreground': '#FAFCFD',
    '--premium-foreground-hsl': '200 43% 99%',
    '--premium-foreground-oklch': 'from #FAFCFD l c h',
    '--premium-hsl': '266 50% 46%',
    '--premium-oklch': 'from #6F3BB2 l c h',
    '--primary': '#0092BD',
    '--primary-foreground': 'oklch(0.99 0.005 194)',
    '--primary-foreground-hsl': '200 43% 99%',
    '--primary-foreground-oklch': '0.99 0.005 194',
    '--primary-hsl': '194 100% 37%',
    '--primary-oklch': 'from #0092BD l c h',
    '--radius': '8px',
    '--rarity-epic': '#6F3BB2',
    '--rarity-epic-hsl': '266 50% 46%',
    '--rarity-epic-oklch': 'from #6F3BB2 l c h',
    '--rarity-legendary': '#AD721C',
    '--rarity-legendary-hsl': '36 72% 39%',
    '--rarity-legendary-oklch': 'from #AD721C l c h',
    '--rarity-rare': '#1C50A7',
    '--rarity-rare-hsl': '218 71% 38%',
    '--rarity-rare-oklch': 'from #1C50A7 l c h',
    '--rarity-secret': '#A20519',
    '--rarity-secret-hsl': '352 94% 33%',
    '--rarity-secret-oklch': 'from #A20519 l c h',
    '--ring': '#0092BD',
    '--ring-hsl': '194 100% 37%',
    '--ring-oklch': 'from #0092BD l c h',
    '--secondary': '#EEF3F5',
    '--secondary-foreground': '#343C42',
    '--secondary-foreground-hsl': '206 12% 23%',
    '--secondary-foreground-oklch': 'from #343C42 l c h',
    '--secondary-hsl': '197 26% 95%',
    '--secondary-oklch': 'from #EEF3F5 l c h',
    '--shadow-card': '0 8px 20px rgba(15, 26, 44, 0.08)',
    '--shadow-card-active': '0 10px 24px rgba(15, 26, 44, 0.12)',
    '--streak': '#2F9F3D',
    '--streak-hsl': '128 54% 40%',
    '--streak-oklch': 'from #2F9F3D l c h',
    '--success': '#2F9F3D',
    '--success-foreground': 'oklch(0.99 0.005 194)',
    '--success-foreground-hsl': '200 43% 99%',
    '--success-foreground-oklch': '0.99 0.005 194',
    '--success-hsl': '128 54% 40%',
    '--success-oklch': 'from #2F9F3D l c h',
    '--tint-primary-subtle': 'hsla(194 100% 37% / 0.15)',
    '--xp': '#0092BD',
    '--xp-bg': '#EEF7FA',
    '--xp-bg-hsl': '195 55% 96%',
    '--xp-bg-oklch': 'from #EEF7FA l c h',
    '--xp-hsl': '194 100% 37%',
    '--xp-oklch': 'from #0092BD l c h'
  }
}
